export default __webpack_public_path__ + "static/headless-checkout-37dafdb75e14315453f9b5891667745a.png";